import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { pushCommentsModal } from '../../../Modals/redux/actionCreators';
import { threadUpdated } from '../../actionCreators';
var mapStateToProps = function (state, _a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, parentId = _a.parentId;
    var _b = getThreadState(state, commentableTypeId, commentableItemId, parentId), streamId = _b.streamId, canPostComment = _b.canPostComment, items = _b.items, maxDepth = _b.maxDepth, lastInsertedCommentId = _b.lastInsertedCommentId;
    return {
        streamId: streamId,
        canPostComment: canPostComment,
        items: items,
        maxDepth: maxDepth,
        lastInsertedCommentId: lastInsertedCommentId,
    };
};
var mapDispatchToProps = {
    onOpenCommentModal: pushCommentsModal,
    onThreadUpdated: threadUpdated,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ThreadStack.container.js.map